import { Component } from 'react';
import NavigationTabLinks from '../containers/navigationTabLinks';
import { WebCache } from '../../services/WebCache';
import {ReactComponent as CalendarSVG} from "itd-common/assets/icons/calendar.svg";
import {ReactComponent as CouponsSVG} from "itd-common/assets/icons/coupons.svg";
import "../settlements/NavigationTabLinksForSettlements.scss"

class NavigationTabLinksForCalendar extends Component {
    render() {
        return (
            <NavigationTabLinks
                items={[
                    ...(WebCache.isFinancialAllowed() || WebCache.isManagementAllowed() ? [
                    {
                        to: '/conciliation/calendar',
                        icon: <CalendarSVG className="tab-icon" />,
                        label: `pages.calendar.conciliationCalendar`
                    },
                    {
                        to: '/conciliation/settlementVouchers',
                        icon: <CouponsSVG className="tab-icon" />,
                        label: `pages.calendar.vouchers`
                    },
                    ] : []),
                    ...((WebCache.isUserARG() && WebCache.isAdvancedAllowed()) ? [
                    {
                        to: '/advanced/search',
                        icon: <CouponsSVG className="tab-icon" />,
                        label: `pages.calendar.advancePayment`
                    },
                    {
                        to: '/advanced/historic',
                        icon: <CalendarSVG className="tab-icon" />,
                        label: `pages.calendar.historic`
                    },
                ] : []),
                ]}
            />
        );
    }
}

export default NavigationTabLinksForCalendar;